
<form #mapForm="ngForm" autocomplete="off">

  <div class="syslog-container" >

    <div>
      <mat-slide-toggle [(ngModel)]="data.syslog.enabled"  color="primary" name="enabled" >
        Enable syslog
      </mat-slide-toggle>
    </div>

  </div>

  <mat-form-field class="fullWidth" >
    <mat-label>Source Type</mat-label>
    <input matInput required [(ngModel)]="data.syslog.sourceType" name="sourceType" [disabled]="true" name="sourceType">

  </mat-form-field>


  <mat-form-field class="fullWidth">
    <mat-label>Host</mat-label>
    <input matInput [(ngModel)]="data.syslog.host" name="host" required>
    <mat-error>
     Host is <strong>required</strong>
    </mat-error>
  </mat-form-field>


  <mat-form-field class="fullWidth">
    <mat-label>Port</mat-label>
    <input type="number" matInput [(ngModel)]="data.syslog.port" [min]="1" [max]="65535" name="port" required>
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Protocol</mat-label>
    <mat-select required [(ngModel)]="data.syslog.protocol" name="protocol" >
      <mat-option *ngFor="let item of protocolOptions" [value]="item">
        {{item}}
      </mat-option>
    </mat-select>
    <mat-error>
      Protocol is <strong>required</strong>
    </mat-error>
  </mat-form-field>


  <mat-form-field class="fullWidth">
    <mat-label>Debug Level</mat-label>
      <mat-select required [(ngModel)]="data.syslog.level" name="level" >
      <mat-option *ngFor="let item of debugLevelOptions" [value]="item">
        {{item}}
      </mat-option>
    </mat-select>
    <mat-error>
      Debug Level is <strong>required</strong>
    </mat-error>
  </mat-form-field>


</form>
